import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ReceitaBrutaAnterior } from '../../../models/receitas-brutas-anteriores.model';
import { ReceitasBrutasAnterioresService } from '../../../services/receitas-brutas-anteriores.service';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { ToastService } from '../../../services/toast.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { ConfirmationService } from 'primeng/api';
import { FormataDataHelper } from '../../../helpers/formata-data.helper';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
@Component({
  selector: 'app-receitas-brutas-anteriores',
  templateUrl: './receitas-brutas-anteriores.component.html',
  styleUrls: ['./receitas-brutas-anteriores.component.scss']
})
export class ReceitasBrutasAnterioresComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();
  @ViewChild('dt') dt: Table | undefined;

  receitasBrutasAnteriores: ReceitaBrutaAnterior[] = [];
  usuarioId: string = '';

  constructor(
    private receitaBrutaAnteriorService: ReceitasBrutasAnterioresService,
    private router: Router,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private jwtHelper: JwtHelper
  ) { }

  ngOnInit() {
    this.tituloChange.emit('Receitas Brutas Anteriores');
    this.iconeChange.emit("pi pi-list");
    this.usuarioId = this.jwtHelper.getUserIdFromToken();
    this.loadReceitasBrutas();
  }

  loadReceitasBrutas() {
    this.spinnerService.show('Carregando Receitas...');

    this.receitaBrutaAnteriorService.getReceitasBrutasAnteriores(this.usuarioId).subscribe({
      next: (data) => {
        this.receitasBrutasAnteriores = this.organizaData(data);
        this.spinnerService.hide();
      },
      error: (e) => {
        console.error('Erro ao carregar Receitas:', e);
        this.toastService.setMensagemToast('Erro ao carregar Receitas.', SeveridadeToast.Error);
        this.spinnerService.hide();
      }
    });
  }

  applyFilterGlobal(event: Event, stringVal: string) {
    this.dt?.filterGlobal((event.target as HTMLInputElement).value, stringVal);
  }

  openNew() {
    this.router.navigate(['/receitas-brutas-anteriores/adicionar']);
  }

  adicionarReceita(id: string) {
    this.router.navigate(['/receitas-brutas-anteriores/adicionar', id]);
  }

  deleteReceita(receita: ReceitaBrutaAnterior) {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja excluir a receita bruta anterior do período ${FormataDataHelper.formatarCompetencia(receita.periodoApuracao)}?`,
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.spinnerService.show('Excluindo receita bruta...');

        this.receitaBrutaAnteriorService.deleteReceitaBrutaAnterior(receita.id).subscribe({
          next: () => {
            this.toastService.setMensagemToast(
              'Receita bruta anterior excluída com sucesso',
              SeveridadeToast.Success
            );
            this.loadReceitasBrutas();
            this.spinnerService.hide();
          },
          error: (err) => {
            console.error('Erro ao excluir receita bruta anterior:', err);
            this.toastService.setMensagemToast(
              'Erro ao excluir receita bruta anterior',
              SeveridadeToast.Error
            );
            this.spinnerService.hide();
          }
        });
      }
    });
  }

  formatCompetencia(pa: number | undefined): string {
    return FormataDataHelper.formatarCompetencia(pa);
  }

  organizaData(data: any): any {
    data = data.sort((periodoUm, periodoDois) => periodoDois.periodoApuracao - periodoUm.periodoApuracao);
    return data;
  }
}
